<template>
    <div class="header-container">
        <div class="header-main" v-if="!searchShow">
            <div class="logo-box">
                <div class="logo-info" @click="goToHome">
                    <img src="https://cdn.bigbays.cn/home/bay-trend-default-bgimg2x.png" alt="" class="logo">
                    <img src="https://cdn.bigbays.cn/home/bay-trend-website-name2x.png" alt="" class="website-name">
                </div>
                <span class="summary">基于微信生态的双域媒体</span>
            </div>
            <div class="menu-box">
                <i class="icon iconfont icon-sousuo" @click="goSearch()"></i>
                <i class="icon iconfont icon-caidan" @click="openMenu()"></i>
            </div>
        </div>
        <div class="header-main-search" v-else>
            <i class="icon iconfont icon-zuojiantou" @click="$router.go(-1)"></i>
            <span>搜索</span>
            <i class="icon iconfont icon-caidan" @click="openMenu()"></i>
        </div>
        <el-drawer :visible.sync="menuDrawer" size="2.32rem" :close-on-press-escape="false" :modal="false" :show-close="false" 
            :withHeader="false" @close="closeMenuDrawer">
            <div class="menu-view-box">
                <div class="scroll-box">
                    <div class="menu-header-box" :class="{before:menuActives.a==0||menuActives.b==0||menuActives.c==0}">
                        <div class="inner-box">
                            <div class="go-back">
                                <i class="icon iconfont icon-fanhui" v-show="secendMenuDrawer||thirdMenuDrawer" @click="goBackMenu()"></i>
                            </div>
                            <div class="attention" @click="toMineFollow()">
                                <span>我的关注</span>
                                <i class="icon iconfont icon-guanzhu"></i>
                            </div>
                        </div>
                    </div>
                    <div class="wrap-view">
                        <div class="menu-wrap" :class="{left1:menuDrawer&&!secendMenuDrawer&&!thirdMenuDrawer,
                            left2:menuDrawer&&secendMenuDrawer&&!thirdMenuDrawer,
                            left3:menuDrawer&&secendMenuDrawer&&thirdMenuDrawer}">
                            <ul class="column-list-box">
                                <li v-for="(item, i) in columnList" :key="i" :class="{active:i==menuActives.a,
                                    before:i+1==menuActives.a}" 
                                    @click="checkFristMenu(i)">
                                    <div class="inner-box">
                                        <span v-if="!item.children||item.children.length==0"></span>
                                        <i class="icon iconfont icon-zuojiantou" v-if="item.children&&item.children.length>0"></i>
                                        <span>{{item.name}}</span>
                                    </div>
                                </li>
                            </ul>
                            <ul class="column-list-box">
                                <li v-for="(item, i) in secendColumnList" :key="i" :class="{active:i==menuActives.b,
                                    before:i+1==menuActives.b}" 
                                    @click="checkSecendMenu(i)">
                                    <div class="inner-box1">{{item.name}}</div>
                                </li>
                            </ul>
                            <!-- <ul class="column-list-box">
                                <li v-for="(item, i) in thirdColumnList" :key="i" :class="{active:i==menuActives.c,
                                    before:i+1==menuActives.c}" 
                                    @click="checkThirdMenu(i)">
                                    <div class="inner-box">
                                        <span></span>
                                        <span>{{item.name}}</span>
                                    </div>
                                </li>
                            </ul> -->
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
export default {
    name: 'HeaderComponent',
    data() {
        return {
            menuDrawer: false,
            secendMenuDrawer: false,
            thirdMenuDrawer: false,
            columnList: [],
            secendColumnList: [],
            thirdColumnList: [],
            // 菜单区收起时判断是返回上一级还是全部收起
            isGoBack: false,
            // 菜单区选中项
            menuActives: {
                a: 0,
                b: -1,
                c: -1
            },
            // 菜单区已展开层级
            menuOpend: {
                a: false,
                b: false,
                c: false
            },
            // 搜索页
            searchShow: false
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.isMobile;
        },
        userInfo() {
            return this.$store.state.userInfo;
        }
    },
    created() {
        this.getSessionData();
        this.Bus.$on('searchShow', res => {
            this.searchShow = res;
        });
    },
    mounted() {
    },
    methods: {
        goToHome(){
            this.$router.push({
                path: '/homeM',
            });
        },
        /**
         * @function getSessionData 获取缓存参数
         */
        getSessionData() {
            let data = window.sessionStorage.getItem('menuOpend'), _data = window.sessionStorage.getItem('menuActives');
            if(data) {
                this.menuOpend = JSON.parse(data);
            }
            if(_data) {
                this.menuActives = JSON.parse(_data);
            }
            this.getColumnList();
        },
        /**
         * @function getColumnList 获取栏目数据
         */
        getColumnList() {
            this.$axios.get(this.Urls.columnList).then(res => {
                this.columnList = res.data.result;
                if(this.menuActives.a > -1) {
                    this.secendColumnList = this.columnList[this.menuActives.a].children;
                    if(this.menuActives.b > -1) {
                        this.checkSecendMenu(this.menuActives.b, true);
                        this.thirdColumnList = this.secendColumnList[this.menuActives.b].children;
                        let f = window.sessionStorage.getItem('fourthColumnList');
                        // if(f) {
                        //     let _f = JSON.parse(f);
                        //     this.$store.commit('setFourthColumn', _f);
                        //     this.Bus.$emit('haveData', true);
                        // }
                    } else {
                        this.checkFristMenu(this.menuActives.a, true);
                    }
                }
                this.$store.commit('setColumnList', this.columnList);
            });
        },
        /**
         * @function openMenu 展开菜单
         */
        openMenu() {
            this.menuDrawer = true;
            if(this.menuOpend.b) {
                this.secendMenuDrawer = true;
                if(this.menuOpend.c) {
                    this.thirdMenuDrawer = true;
                }
            }
        },
        /**
         * @function goBackMenu 返回上一级菜单
         */
        goBackMenu() {
            this.isGoBack = true;
            if(this.thirdMenuDrawer) {
                this.thirdMenuDrawer = false;
            } else {
                if(this.secendMenuDrawer) {
                    this.secendMenuDrawer = false;
                }
            }
        },
        /**
         * @function closeMenuDrawer 收起菜单区
         */
        closeMenuDrawer() {
            if(!this.isGoBack) {
                this.menuDrawer = this.secendMenuDrawer = this.thirdMenuDrawer = false;
            }
            this.isGoBack = false;
        },
        /**
         * @function toMineFollow 去我的关注页面
         */
        toMineFollow() {
            window.sessionStorage.setItem('mineFollow', JSON.stringify({index: 0}));
            this.closeMenuDrawer();
            this.$router.push({
                path: '/userMineFollowM',
                query: { type: 1 }
            });
        },
        /**
         * @function checkFristMenu 点击一级菜单事件
         * @param { number } i 点击第i项
         */
        checkFristMenu(...args) {
            let i = args[0];
            this.menuActives = { a: i, b: -1, c: -1 };
            this.menuOpend = { a: true, b: false, c: false };
            // this.$store.commit('setFourthColumn', []);
            let obj = {
                columnId: this.columnList[i].id,
                columnName: this.columnList[i].name,
                columnInfo: this.columnList[i].about,
                qrcode: this.columnList[i].qrcode_path
            };
            this.$store.commit('setNowColumnParams', obj);
            let child = this.columnList[i].children;
            if(child && child.length > 0) {
                this.secendColumnList = child;
                this.secendMenuDrawer = true;
            } else {
                this.isGoBack = false;
                this.closeMenuDrawer();
            }
            this.setSessionData();
            // this.getArticleList(this.columnList[i].id);
            let item = {
                id: this.columnList[i].id,
                name: this.columnList[i].name
            };
            if(args.length == 1) {
                if(i == 0) {
                    this.$router.push({path: '/homeM'});
                } else {
                    this.toColumnContentPage(item);
                    this.Bus.$emit('columnChanged', true);
                }
            }
        },
        /**
         * @function checkSecendMenu 点击二级菜单事件
         * @param { number } i 点击第i项
         */
        checkSecendMenu(...args) {
            let i = args[0];
            this.menuActives.b = i;
            this.menuActives.c = -1;
            this.menuOpend.b = true;
            this.menuOpend.c = false;
            let obj = {
                columnId: this.secendColumnList[i].id,
                columnName: this.secendColumnList[i].name,
                columnInfo: this.secendColumnList[i].about,
                qrcode: this.secendColumnList[i].qrcode_path
            };
            this.$store.commit('setNowColumnParams', obj);
            let child = this.secendColumnList[i].children;
            let topColumnList = child && child.length > 0 ? child : [];
            this.$store.commit('setFourthColumn', topColumnList);
            this.isGoBack = false;
            this.closeMenuDrawer();
            this.setSessionData();
            // this.getArticleList(this.secendColumnList[i].id);
            if(args.length == 1) {
                let item = {
                    id: this.secendColumnList[i].id,
                    name: this.secendColumnList[i].name
                };
                this.toColumnContentPage(item);
                this.Bus.$emit('columnChanged', true);
            }
        },
        /**
         * @function checkThirdMenu 点击三级菜单事件
         * @param { number } i 点击第i项
         */
        checkThirdMenu(i) {
            this.menuActives.c = i;
            this.menuOpend.c = true;
            let child = this.thirdColumnList[i].children;
            if(child && child.length > 0) {
                this.$store.commit('setFourthColumn', child);
                this.Bus.$emit('haveData', true);
            } else {
                this.$store.commit('setFourthColumn', []);
            }
            this.closeMenuDrawer();
            this.setSessionData();
            this.getArticleList(this.thirdColumnList[i].id);
            let item = {
                id: this.thirdColumnList[i].id,
                name: this.thirdColumnList[i].name
            };
            this.toColumnContentPage(item);
        },
        /**
         * @function getArticleList 获取栏目文章列表数据
         * @param 栏目id
         */
        getArticleList(id) {
            this.$axios.get(this.Urls.articleList, {
                params: {
                    limit: 10,
                    page: 1,
                    column_id: id
                }
            }).then(res => {
                let data = res.data.result.data, total = res.data.result.total;
                if(data.length > 0) {
                    for(let i = 0; i < data.length; i++) {
                        if(data[i].cover) {
                            data[i].cover = this.cm.jointPicUrl(data[i].cover);
                        }
                        if(data[i].updated_at) {
                            // data[i].updated_at = this.cm.transformTime(data[i].updated_at, false);
                            // data[i].updated_at = String(data[i].updated_at).split(' ')[0];
                            data[i].created_at = String(data[i].created_at).split(' ')[0];
                        }
                    }
                }
                let articleData = {
                    list: data,
                    total: total
                };
                this.$store.commit('setColumnArticleData', articleData);
            });
        },
        /**
         * @function toColumnContentPage 去栏目内容页
         * @param { object } item 页面参数
         */
        toColumnContentPage(item) {
            this.$router.push({
                path: '/columnContentListM',
                query: {
                    // column_id: item.id,
                    // column_name: item.name
                }
            });
        },
        /**
         * @function goSearch 去搜索页
         */
        goSearch() {
            this.$router.push({path: '/searchM'});
        },
        /**
         * @function setSessionData 设置页面缓存参数
         */
        setSessionData() {
            window.sessionStorage.setItem('menuOpend', JSON.stringify(this.menuOpend));
            window.sessionStorage.setItem('menuActives', JSON.stringify(this.menuActives));
        }
    }
}
</script>
<style lang="scss" scoped>
@import './HeaderComponent.scss';
</style>
<style lang="scss">
@media screen and (max-width: 500px) {
    .menu-view-box {
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, #090723 0%, #5A596C 100%);
        box-shadow: 0rem 0rem 0.06rem rgba(0, 0, 0, .35);
        .scroll-box {
            width: 100%;
            height: 100%;
            // height: calc(100% - 0.2rem);
            // padding-bottom: 0.2rem;
            // padding: 0 0.16rem 0.2rem 0.17rem;
            .menu-header-box {
                width: calc(100% - 0.33rem);
                height: 0.52rem;
                padding: 0 0.16rem 0 0.17rem;
                .inner-box {
                    display: flex;
                    justify-content: space-between;
                    widows: 100%;
                    height: calc(100% - 0.01rem);
                    border-bottom: 0.01rem solid rgba(255, 255, 255, .4);
                    .go-back {
                        margin-top: 0.2rem;
                        > i {
                            font-size: 0.16rem;
                            color: #fff;
                            opacity: .8;
                        }
                    }
                    .attention {
                        margin-top: 0.16rem;
                        opacity: .8;
                        span {
                            font-size: 0.16rem;
                            color: #fff;
                        }
                        i {
                            color: #ED4040;
                        }
                    }
                }
            }
            .before {
                .inner-box {
                    border: none;
                }
            }
            .wrap-view {
                position: relative;
                width: 100%;
                height: calc(100% - 0.52rem);
                overflow: hidden;
                .menu-wrap {
                    position: absolute;
                    top: 0;
                    display: flex;
                    flex-wrap: nowrap;
                    height: 100%;
                    transition: left .3s;
                    .column-list-box {
                        width: 2.32rem;
                        >li {
                            width: calc(100% - 0.33rem);
                            height: 0.51rem;
                            padding: 0 0.16rem 0 0.17rem;
                            .inner-box {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                width: 100%;
                                height: calc(100% - 0.01rem);
                                border-bottom: 0.01rem solid rgba(255, 255, 255, .4);
                                span, i {
                                    font-size: 0.16rem;
                                    color: #fff;
                                    opacity: .8;
                                }
                            }
                            .inner-box1 {
                                width: 100%;
                                height: calc(100% - 0.01rem);
                                border-bottom: 0.01rem solid rgba(255, 255, 255, .4);
                                font-size: 0.16rem;
                                color: #fff;
                                text-align: right;
                                line-height: 0.5rem;
                                opacity: .8;
                            }
                        }
                        .before {
                            .inner-box {
                                border: none;
                            }
                        }
                        .active {
                            height: 0.49rem;
                            background: rgba(33, 90, 146, .6);
                            border-top: 0.01rem solid rgba(255, 255, 255, .4);
                            border-bottom: 0.01rem solid rgba(255, 255, 255, .4);
                            .inner-box {
                                border: none;
                            }
                        }
                    }
                }
                .left1 {
                    left: 0;
                    transition: left .3s;
                }
                .left2 {
                    left: -2.32rem;
                    transition: left .3s;
                }
                .left3 {
                    left: -4.64rem;
                    transition: left .3s;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/common/header/HeaderComponent.vue